import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useGiftCardsSearchParams } from '../email-pulse.hooks';
import EmailPulseHeader from '../email-pulse-header/email-pulse-header.component';
import GiftCardsSummaryCards from './gift-cards-summary-cards.component';
import ApiDetailsDrawer from '../email-pulse-api-definitions/api-details-drawer.component';
import { transformEmailPulseDataGridResponse } from '../email-pulse.utils';
import {
  useGetEmailPulseGiftCardsSummaryQuery,
  useGetEmailPulseGiftCardsEmailsOpenedBreakdownQuery,
  useGetEmailPulseGiftCardsEmailsBouncedBreakdownQuery,
  useGetEmailPulseGiftCardsDataQuery,
  useExportEmailPulseGiftCardsMutation,
} from 'api/reports-service/email-pulse-hooks';
import GiftCardsDataGrid from './gift-cards-data-grid/gift-cards-data-grid.component';

const filteredSearchParams = [
  'storeIds',
  'campaignIds',
  'offerIds',
  'messageIds',
  'status',
];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useGiftCardsSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <GiftCards />
    </SearchParamsProvider>
  );
};

const GiftCards = () => {
  const { open, close, isOpen } = useDrawer();

  const giftCardsSummary = useSearchQuery(
    useGetEmailPulseGiftCardsSummaryQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsOpenedBreakdown = useSearchQuery(
    useGetEmailPulseGiftCardsEmailsOpenedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsBouncedBreakdown = useSearchQuery(
    useGetEmailPulseGiftCardsEmailsBouncedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const giftCardsDataGrid = useSearchQuery(useGetEmailPulseGiftCardsDataQuery, {
    filteredSearchParams,
    getSearchResults: response =>
      transformEmailPulseDataGridResponse(response, 'id', 'emailTypeDisplay'),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            giftCardsSummary,
            emailsOpenedBreakdown,
            emailsBouncedBreakdown,
            giftCardsDataGrid,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />
          <EmailPulseHeader open={open} />

          {/* Summary Cards */}
          <GiftCardsSummaryCards />

          {/* Data Grid */}
          <Box height={{ xs: 400, sm: 600 }}>
            <GiftCardsDataGrid
              data-testid="GiftCards.GiftCardsDataGrid"
              queryName="giftCardsDataGrid"
              useExportMutation={useExportEmailPulseGiftCardsMutation}
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
      <ApiDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
